import React from 'react'
import { useEffect, useContext, useState } from 'react';
import $ from 'jquery';
import SglContext from '../SglContext';
import './archiveStream.css'
import { Link } from 'react-router-dom';
import noImageAvailable from '../images/no-image-avaliable.jpg';

var moment = require('moment');
const axios = require("axios").default;

export default function ArchiveStream() {

    const [archive_events, setArchiveEvents] = useState([]);
    const Sgl = useContext(SglContext)
    const switch_company_name = Sgl.switches.company_name ? Sgl.switches.company_name : "The Company"
    const special_events = Sgl.switches['switches'].find((element) => { return element['switch_name'] == 'Videos - Special Events Live Streaming' })
    const special_events_switch = special_events.value
    const initialevent2 = document.getElementById("archive-event0");

    // const slider2 = document.querySelector(".sgl-archive-slider");
    var event_spacing2 = 35;
    let activeIndex2 = 0; // the current page on the slider

    useEffect(() => {
        getAllData();

        window.addEventListener('resize', toggleArchiveSliderPagination, true)

        return () => {
            window.removeEventListener('resize', toggleArchiveSliderPagination, true)
        }
    }, []);


    const btnLeftClick = () => {
        const slider2 = document.querySelector(".sgl-archive-slider");
        let baseSliderWidth2 = document.querySelector(".sgl-archive-slider").offsetWidth;
        let eventWidth = document.querySelector(".sgl-archive-event").getBoundingClientRect().width;
        let slide_shift = Math.floor(baseSliderWidth2 / eventWidth);
        if (slide_shift < 1) {
            slide_shift = 1;
        }
        let scrollDistance = eventWidth * slide_shift + (event_spacing2 * slide_shift);

        slider2.scrollBy({
            top: 0,
            left: -scrollDistance,
            behavior: "smooth",
        });
        activeIndex2 = (activeIndex2 - 1) % 3;
    };

    // Scroll Right button
    const btnRightClick = () => {
        const slider2 = document.querySelector(".sgl-archive-slider");
        let baseSliderWidth2 = document.querySelector(".sgl-archive-slider").offsetWidth;
        let eventWidth = document.querySelector(".sgl-archive-event").getBoundingClientRect().width;
        let slide_shift = Math.floor(baseSliderWidth2 / eventWidth);
        if (slide_shift < 1) {
            slide_shift = 1;
        }
        let scrollDistance = eventWidth * slide_shift + (event_spacing2 * slide_shift);


        // if we're on the last page
        if (activeIndex2 == 2) {
            // duplicate all the items in the slider (this is how we make 'looping' slider)
            slider2.scrollBy({
                top: 0,
                left: +scrollDistance,
                behavior: "smooth",
            });
            activeIndex2 = 0;
        } else {
            slider2.scrollBy({
                top: 0,
                left: +scrollDistance,
                behavior: "smooth",
            });
            activeIndex2 = (activeIndex2 + 1) % 3;
        }
    };

    const getAllData = () => {
        const formData = new URLSearchParams();
        formData.append('customer_id', Sgl.company_id);
        formData.append('limit', 30);

        axios.post(Sgl.nestApiUrl + '/livestream/getArchiveLivestreams', formData, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res => {
            const processedEvents = res.data.map(event => {
                return {
                    ...event,
                    placeholder_image: event.placeholder_image && event.placeholder_image.trim() !== '' 
                        ? event.placeholder_image 
                        : noImageAvailable 
                };
            });
            setArchiveEvents(processedEvents);
        }).catch(error => {
            console.error('Error fetching archive livestreams:', error);
        });
    }

    const Label = (name) => {
        if (name.length > 55) {
            let result = name.substring(0, 55);
            name = result + "..."

        }

        return name;
    }


    const toggleArchiveSliderPagination = () => {
        let baseSliderWidth2 = document.querySelector(".sgl-archive-slider").offsetWidth;
        let eventWidth = document.querySelector(".sgl-archive-event").getBoundingClientRect().width;
        let event_count = $(".sgl-archive-event").length;
        let event_total_width = (eventWidth * event_count) + (event_spacing2 * event_count) - event_spacing2;
        if (event_total_width <= baseSliderWidth2) {
            $(".sgl-livestream-container#archive-livesteam-container .sgl-btn-nav").hide();
        } else {
            $(".sgl-livestream-container#archive-livesteam-container .sgl-btn-nav").show();
        }
    }

    return (
        <div>
            {(archive_events.length != 0 && special_events_switch == 1) &&
                <div className="sgl-livestream-container" id="archive-livesteam-container">
                    <div className="sgl-heading">
                        <h3 className="sgl-title">
                            <b></b><span>Archive Live Streams</span><b></b><Link to="/livestream" target="_blank">View All </Link>
                        </h3>
                    </div>
                    <div className="sgl-list">
                        {archive_events.length >= 3 &&
                            <span id="sgl-archive-moveLeft" className="sgl-btn-nav" onClick={() => (btnLeftClick())}>
                                &#8249;
                            </span>
                        }

                        <div id="sgl-archive-slider" className="sgl-archive-slider">
                            {archive_events.map((event, index) => {
                                return (
                                    <div key={index} className="sgl-archive-event" id="archive-event0">
                                        <Link className="sgl-link" to={"/livestream/detail?se_id=" + event.sgl_id} >
                                            <img
                                                src={event.placeholder_image}
                                                alt="" srcSet="" />
                                            <div className="sgl-description">
                                                <div className="sgl-text">
                                                    {Label(event.title)}
                                                </div>
                                            </div>
                                            <div className="sgl-badge">
                                                <div className="sgl-badge-inner">
                                                    <span className="sgl-day">{moment(event.event_date).format("D")}</span>
                                                    <span className="sgl-month">{moment(event.event_date).format("MMM")}</span>
                                                    <span className="sgl-year">{moment(event.event_date).format("YYYY")}</span>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                )
                            })}

                        </div>
                        {archive_events.length >= 3 &&
                            <span id="sgl-archive-moveRight" className="sgl-btn-nav" onClick={() => { btnRightClick() }}>
                                &#8250;
                            </span>
                        }

                    </div>
                </div>
            }
        </div >
    )
}
